import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";

import React, { useEffect, useRef, useState } from "react";
import { Loading } from "app/components";
import { getSessionUserInformation } from "app/utils/utility.service";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { formatNumber } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { getSessionClientInformation } from "app/utils/utility.service";
import { insertLogs } from "app/views/home-purchase/HomePurchaseStep3/homepurchase.service";
import { deleteCoupon, deleteCoupons, fetchCoupons } from "../subscription.service";
import moment from "moment";
import "../Subscription.css";
import AddCoupons from "./AddCoupons";
  const initialState = {
    code: "",
    discountType: "",
    discount_value : 0,
    maxRedemptions:0,
    applicableRoles: ['agent','broker','client'],
    redeemBy : "",
    planId: "",
    startDate :"",
     is_active: true,
  };

const Coupons = () => {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  let sessionValues =
      clientId && clientId !== "null"
        ? getSessionClientInformation()
        : getSessionUserInformation();
  const clientInfo = getSessionClientInformation();
  if (clientInfo) {
    sessionValues = clientInfo;
  }
  const userId =
  clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [title, setTitle] = useState("");
  const [values, setValues] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [couponDetails, setCouponDetails] = useState([]);
  const [pdate, setPdate] = useState("");
  
 
  const [couponModal, setCouponModal] = useState(false);
  const toast = useRef();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };

  useEffect(() => {
    setIsLoading(true);
  
    fetchCouponData();
  }, []);


  const fetchCouponData = async () => {

    let list = await fetchCoupons();
    if (list != null && list.data?.coupons?.length >0) {
      setIsLoading(false);
     
       
      setCouponDetails(list.data.coupons);

    } else {
      setIsLoading(false);
      setCouponDetails([]);
     
    }
  };



  const curpriceTemplate = (rowData) => {
    return <span>{"$ " + formatNumber(rowData.current_price)}</span>;
  };
  const purpriceTemplate = (rowData) => {
    return <span>{"$ " + formatNumber(rowData.purchasePrice)}</span>;
  };
  const endDateTemplate = (rowData) => {
    const formattedDate = rowData.redeemBy? moment(rowData.redeemBy).format('MM-DD-YYYY') : "";
    return <span>{formattedDate}</span>;
  };
   const roleTemplate = (rowData) => {
    return (
      <span>
        {Array.isArray(rowData.applicableRoles) 
          ? rowData.applicableRoles.join(', ')
          : rowData.applicableRoles || 'N/A'
        }
      </span>
    );
  };
   const statusTemplate = (rowData) => {
    console.log("row "+JSON.stringify(rowData))
    return (
      <span>
        {rowData.is_active ? 'Active' : 'Inactive'}
      </span>
    );
  };
   const startDateTemplate = (rowData) => {
    const formattedDate = moment(rowData.startDate?rowData.startDate:rowData.createdAt).format('MM-DD-YYYY');
    return <span>{formattedDate}</span>;
  };

    const discountValueTemplate = (rowData) => {
      return <span>{"$ " + formatNumber(rowData.discountValue)}</span>;
    };
   const handleAddCouponModal = () => {
      if (!couponModal) {
        const payload = {
          description: "Coupons",
        };
        insertLogs(payload);
      }
      setTitle("Add Coupon");
      setValues({
        userId: userId,
        is_active: true,
        applicableRoles: ['agent', 'broker', 'client'],
        code: "",
        discountType: "",
        discountValue: 0,
        maxRedemptions: 0,
        redeemBy: "",
        planId: "",
        startDate: ""
      });
      setCouponModal(!couponModal);
    };
    const renderCouponModal = () => (
      <AddCoupons
        couponModal={couponModal}
        handleAddCouponModal={handleAddCouponModal}
        title={title}
        couponDetails={couponDetails}
        setCouponDetails={setCouponDetails}
        values={values}
        setValues={setValues}
        pdate={pdate}
      />
    );
    const setEditValues = (rowData) => {
      setTitle("Edit Coupon");
     
      setValues({
        ...values,
        code: rowData.code,
        applicableRoles: rowData.applicableRoles,
        startDate: rowData.startDate,
        redeemBy: rowData.redeemBy,
        discountValue: rowData.discountValue,
        status: rowData.status, 
        id: rowData.id,
        is_active:rowData.is_active,
        maxRedemptions:rowData.maxRedemptions
        
      });
      setCouponModal(!couponModal);
     
    };
  const actionTemplate = (rowData, options) => {
    const menu = React.createRef();

    const handleEdit = () => {
      setEditValues(rowData);
     
    };

    const handleDelete = async () => {
      const details = await deleteCoupon(rowData.code);
      if (details) {
        showSuccess("Coupon deleted successfully");
        // insert settings value
        setIsLoading(false);
        setTimeout(() => {
          fetchCouponData();
        }, 1000);
      } else {
        showError("Error");
      }
    };


    const items = [
      { label: "Edit", command: handleEdit },
      { label: "Delete", command: handleDelete }
    ];

    return (
      <>
        <Menu model={items} popup ref={menu} />

        <i
          style={{ cursor: "pointer" }}
          className="pi pi-ellipsis-v"
          onClick={(event) => {
            menu.current.toggle(event);
          }}
        ></i>
      </>
    );
  };
  // Custom body template to render hyperlinks
  const linkTemplate = (rowData, options) => {
    return (
      <span
        style={{
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={() => setEditValues(rowData)}
      >
        {rowData.crypto_name}
      </span>
    );
  };
  return (
    <div style={{ margin: "2rem" }}>
      {isLoading && <Loading />}
      <div className="col-2"></div>

        <div className="col-12" style={{textAlign:"end"}}>
          <Button
            type="button"
            label="Add Coupon"
            className="p-button-raised p-button-warning mr-4"
            onClick={handleAddCouponModal}
          />
        </div>
      <div>
        <Toast ref={toast} className="ToastMessage" />

        <DataTable
          value={couponDetails}
          className="clients-plans-table mt-3"
          responsiveLayout="scroll"
          emptyMessage="Please add coupon"
          scrollHeight="65vh"
          style={{"width":"90vw"}}
          scrollDirection="both"
          rows={10}
          loading={isLoading}
          paginator={couponDetails.length > 10}
          rowHover
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink   CurrentPageReport"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <Column style={{"width":"4%"}} body={(data, options) => options.rowIndex + 1} header="ID"/>
          <Column
            sortable
            field="crypto_name"
            header="Role"
            style={{ width: "25%" }}
            body={roleTemplate}
            className="plan-name-column"
          />
            <Column
            field="code"
            className="no-wrap price-column"
            header="Coupon Code "
          />
           <Column
            field="startDate"
            className="no-wrap date-column"
            header="Start Date"
            body={startDateTemplate}
          />
        <Column
            field="redeemBy"
            header="End Date" 
            className="date-column"
            body={endDateTemplate}
          />
           <Column
            field="discountValue"
            header="Discount"
            className="price-column"
            body={discountValueTemplate}
          />
             <Column
            field="valid"
            header="Status"
            className="status-column"
            body={statusTemplate}
          />
          <Column field="Actions" body={actionTemplate} header="Actions" className="action-column" />
        </DataTable>
        {couponModal && renderCouponModal()}
      </div>
    </div>
  );
};

export default Coupons;
